import { AppConfig } from './../../../app.config';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { UntypedFormGroup, NgForm, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { HttpParams } from '@angular/common/http';
import * as AuthActions from 'src/app/store/auth/actions/auth.actions';
import { AuthReset } from 'src/app/models/auth';
import { MatchPassword } from 'src/app/utils/password-validation';
import { IAppState } from 'src/app/store/state/app.state';
import { getResetPasswordState } from 'src/app/store/auth/selectors/auth.selectors';
import { IResetPasswordState } from 'src/app/store/state/auth.resetpassword.state';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  authSubscription: Subscription;
  resetPasswordForm: UntypedFormGroup;
  formTitle = 'Choose new password';
  hide = true;
  resetFailText = '';
  showSpinner = false;
  resetPasswordFail = false;
  resetPasswordSuccess = false;
  email = '';
  token = '';
  passwordUpdatedSuccess: boolean;
  successText: string;
  fromInvitation: boolean;

  @ViewChild('f') form: NgForm;

  constructor(private appConfig: AppConfig, private store: Store<IAppState>, private route: ActivatedRoute) { }

  ngOnInit() {

    this.authSubscription = this.store.pipe(select(getResetPasswordState)).subscribe((state: IResetPasswordState) => {
      if (!state) {
        return;
      }
      this.showSpinner = state.loading;
      this.enableDisableForm(this.form, !state.loading);
      this.resetFailText = state.resetFailText;
      this.resetPasswordFail = (state.resetFail && !state.resetSuccess);
      this.resetPasswordSuccess = (!state.resetFail && state.resetSuccess);
    });

    this.resetPasswordForm = new UntypedFormGroup({
      'password': new UntypedFormControl(null, [Validators.required, Validators.pattern('(^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*_0-9]).*$)')]),
      'confirmPassword': new UntypedFormControl(null, [Validators.required, Validators.pattern('(^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*_0-9]).*$)')])
    },
      MatchPassword
    );
    // check to see if the user redirected to here from the invite mail
    this.fromInvitation = this.route.snapshot.params['invite'] ? true : false;

    this.route.queryParams
      .subscribe(
        (params: Params) => {
          this.email = params['email'];
          this.token = params['token'];
        }
      );
  }

  private enableDisableForm(form: NgForm, enable: boolean) {
    if (form) {
      if (enable) {
        form.form.enable();
      } else {
        form.form.disable();
      }
    }
  }

  onInputChange(form: NgForm) {
    if (form.valid) {
      this.resetPasswordFail = false;
    }
  }

  onBlur(form: NgForm) {
    if (!form.valid) {
      this.processError(form);
    } else {
      this.resetPasswordFail = false;
    }
  }

  processError(form: NgForm) {
    const formControls = form.form.controls;
    for (const controlKey in formControls) {
      if (formControls[controlKey]) {
        const control = formControls[controlKey];
        if (control.status !== 'VALID') {
          const errors = control.errors;
          for (const error in errors) {
            if (error) {
              switch (error) {
                case 'required':
                  this.resetFailText = "One more password fields required";
                  break;
                case 'MatchPassword':
                  this.resetPasswordFail = true;
                  this.resetFailText = "Passwords don't match";
                  break;
                case 'pattern':
                  this.resetPasswordFail = true;
                  this.resetFailText = "Passwords must be at least 8 characters and contain at least one uppercase, lowercase and a digit or special character";
                  break;
                default:
                  return 'One or more fields are incorrect';
              }
            }
          }
        }
      }
    }
  }

  toggleHide() {
    this.hide = !this.hide;
  }

  onSubmit(form: NgForm) {
    let httpParams = new HttpParams();
    const paramsObject: AuthReset = {
      passwordToken: <string>this.token,
      userId: <string>this.email,
      newPassword: <string>form.value.password,
      // a check to see if the user was redirected to here from the invite link from email
      fromInvitation: this.fromInvitation,
      siteId: Number.parseInt(this.appConfig.getEnvironment().siteId, 10),
      clientId: <string>this.appConfig.getEnvironment().clientId,
      managerId: this.appConfig.getEnvironment().managerEntityId
    };

    for (const key in paramsObject) {
      if (key) {
        httpParams = httpParams.set(key, paramsObject[key]);
      }
    }
    this.store.dispatch(new AuthActions.ResetPassword(httpParams));
  }


  ngOnDestroy() {
    this.authSubscription.unsubscribe();
  }
}
